import styled from "styled-components"
import margins from "../MarginContainer"

const Subtitle = styled.h1`
  color: #000000cc;
  font-size: 1.3em;
  font-family: Recife Text, serif;
  font-weight: 300;
  ${margins};
`

export default Subtitle
